import styled from 'styled-components'

export const InputModal = styled.div`
  background-color: white;
  width: 50%;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ddcece;
  position: fixed;
  z-index: 9;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  input {
    &:focus:not(:disabled) {
      box-shadow: 0px 0px 0px 1px #9a84c8, 0px 0px 0px 1px rgb(118 69 217 / 60%);
    }
  }
  .flexsb {
    display: flex;
    justify-content: space-between;
  }
  .flexend {
    display: flex;
    justify-content: end;
  }
  .marginl1 {
    margin-left: 1rem;
  }
  .margintb1 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  .margint1 {
    margin-top: 2rem;
  }
  .cursor {
    cursor: pointer;
  }
  .borderred {
    border-color: red;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`
export const InputModalItem = styled.div`
  min-height: 40px;
`
